import { DegreeType, GradeType } from 'types';

export const degreeTypeOptions = [
	{
		label: DegreeType.Bachelors,
		value: DegreeType.Bachelors,
	},
	{
		label: DegreeType.School,
		value: DegreeType.School,
	},
	{
		label: DegreeType.HighSchool,
		value: DegreeType.HighSchool,
	},
	{
		label: DegreeType.Diploma,
		value: DegreeType.Diploma,
	},
	{
		label: DegreeType.PostGraduateDiploma,
		value: DegreeType.PostGraduateDiploma,
	},
	{
		label: DegreeType.Masters,
		value: DegreeType.Masters,
	},
	{
		label: DegreeType.Doctorate,
		value: DegreeType.Doctorate,
	},
];

export const gradeTypeOptions = [
	{
		label: GradeType.Percentage,
		value: GradeType.Percentage,
	},
	{
		label: GradeType.GradePointAverage,
		value: GradeType.GradePointAverage,
	},
];
